export default __webpack_public_path__ + "static/media/mora.af2c85f4.png";